import React from 'react';

import { Root, type DividerOrientation, type DividerVariant } from './Divider.styles';

export type DividerProps = {
  /** Visual treatment. `basic` = flat hairline (the Money Flow style); `styled` =
   *  a hairline that fades to transparent at both ends (the Billing Summary style). */
  variant?: DividerVariant;
  /** Line direction. `vertical` stretches to fill a flex row's cross axis. */
  orientation?: DividerOrientation;
  className?: string;
};

/**
 * The standard separator for the nova area. One rule for every divider:
 * `<Divider />` for a plain hairline, `variant="styled"` for the fading gradient
 * line, `orientation="vertical"` to split a row. Don't hand-roll divider divs.
 */
export const Divider = ({
  variant = 'basic',
  orientation = 'horizontal',
  className,
}: DividerProps): React.ReactElement => (
  <Root
    $variant={variant}
    $orientation={orientation}
    role="separator"
    aria-orientation={orientation}
    className={className}
  />
);

export default Divider;
